module.exports = __webpack_public_path__ + "img/teacher-stundets.974753a6.jpg";